import { CorePlan, PaperPlanPlanType } from 'src/constants/enums';
import { CORE_PLAN_MAPPING, ICorePlanMetadata } from 'src/constants/rateCards';
import { IPlanValues } from 'src/types/IPaperPlan';

import { GLOBAL_TERRITORY } from './context';

export const DEFAULT_PROMO_AFFILIATE_NAME = 'Amazon Music Unlimited';

export const defaultPlanValues: IPlanValues = {
    paperPlanName: '',
    displayName: '',
    reportingName: '',
    subscriptionProduct: '',
    affiliateName: DEFAULT_PROMO_AFFILIATE_NAME,
    description: '',
    employeePlan: false,
    carrierPlan: false,
    royaltyBearing: true,
    customerPays: true,
    planType: '',
    planGroup: '',
    territory: GLOBAL_TERRITORY.NAME,
    startDate: '',
    endDate: '',
    renewalCadence: '',
    promoDurationInDays: '',
    wholesalePrice: '',
    endUserPrice: '',
    wholesalePriceCurrency: '',
    endUserPriceCurrency: '',
    isRenewalCadenceChecked: true,
    isPromotion: false,
    isHD: false,
    isBundle: false,
    promoMultiplier: '1'
};

export const PLAN_TYPE_OPTIONS = [
    PaperPlanPlanType.Individual,
    PaperPlanPlanType.Family,
    PaperPlanPlanType.SingleDevice,
    PaperPlanPlanType.Student
];

export const RENEWAL_CADENCE_OPTIONS = ['Monthly', 'Annual', 'Daily', 'Weekly'];

export const PROMO_DURATION_OPTIONS = ['14.0', '30.0', '60.0', '90.0', '120.0', '150.0', '180.0'];

export const CORE_PLAN_IDS = Object.values(CORE_PLAN_MAPPING).map(
    (metadata: ICorePlanMetadata) => metadata.paperPlanName
);

export const GLOBAL_PLAN_METADATA_TERRITORY_CODE = '00';

export const TERRITORY_DEPENDENT = 'Territory Dependent';
